import { Directive, ElementRef, effect, inject, input } from '@angular/core';

@Directive({
  selector: '[camRenderedContent]',
})
export class CamRenderedContentDirective {
  camRenderedContent = input<HTMLElement | string | null>(null);

  private readonly _host = inject<ElementRef<HTMLElement>>(ElementRef);

  constructor() {
    effect(() => {
      const content = this.camRenderedContent();
      const element = this._host.nativeElement;
      element.replaceChildren();
      if (!content) {
        return;
      }
      if (typeof content === 'string') {
        element.innerHTML = content;
        return;
      }
      element.appendChild(content);
    });
  }
}
